import React from 'react';
import styled from '@emotion/styled';

const TextInputStyle = styled.div`
  width: 100%;
  input {
    width: 100%;
    border: 1px solid #eeeeee;
    color: #4A4A4A;
    border-radius: 40px;
    font-size: 16px;
    font-family: inherit;
    padding-top: 0px;
    padding: 13px 10px 13px 20px;
    box-sizing: border-box;
    font-weight: 200;
    ::placeholder {
      color: #A7A8A9; 
      font-size: 16px;
      font-weight: 400;
    }
  }
`

export function TextInput({
  /* props and their default values */
  type = 'text',
  value = '',
  autoFocus = false,
  tabIndex = 0,
  spellCheck = false,
  autoComplete = 'off',
  placeholder = null,
  onBlur = () => {},
  onChange = () => {},
  dataQa = 'TextInput'
}) {
  return (    
    <TextInputStyle>
      <input        
        value={value}
        type={type}
        autoFocus={autoFocus}
        tabIndex={tabIndex}
        spellCheck={spellCheck}
        autoComplete={autoComplete}
        placeholder={placeholder}
        onBlur={onBlur}
        onChange={onChange}
        data-qa={dataQa}
      />
    </TextInputStyle>
  )
}



// WEBPACK FOOTER //
// ./src/modules/app/util/TextInput.jsx